import {API_BASE_URL} from '../services/authApi';

export const getAssetUrl = (url?: string) => {
  if (!url) {
    return '';
  }

  if (
    url.startsWith('http://') ||
    url.startsWith('https://') ||
    url.startsWith('data:') ||
    url.startsWith('blob:')
  ) {
    return url;
  }

  if (API_BASE_URL.startsWith('http://') || API_BASE_URL.startsWith('https://')) {
    try {
      return new URL(url, API_BASE_URL).toString();
    } catch (error) {
      return url;
    }
  }

  return url;
};

export const getDisplayInitial = (name?: string) => name?.trim().charAt(0).toUpperCase() || 'U';
